import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { title: 'Tag Name', field: 'tagName', filterAndSearch: true },
        //{ title: 'No Of Uses', field: 'uses', filterAndSearch: false }
    ],
})

export const data = [
    {
        "tagName": "Tag Name",
        "uses": "112",
    },
    {
        "tagName": "Tag Name",
        "uses": "113",
    },
    {
        "tagName": "Tag Name",
        "uses": "114",
    },
    {
        "tagName": "Tag Name",
        "uses": "115",
    }
];

export default tableConfig;